import { z } from 'zod';
import { IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
import { PermissionSchema } from './permissions.js';
export const OrganizationStatusSchema = z.enum(['active', 'inactive']);
export const OrganizationSchema = z.strictObject({
    id: IdSchema,
    name: z.string(),
    slug: z.string(),
    status: OrganizationStatusSchema,
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateOrganizationRequestSchema = z.strictObject({
    name: z.string().trim().min(2).max(200),
    slug: z
        .string()
        .trim()
        .min(2)
        .max(80)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
});
export const UpdateOrganizationRequestSchema = z.strictObject({
    name: z.string().trim().min(2).max(200).optional(),
    status: OrganizationStatusSchema.optional(),
});
export const RoleSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    name: z.string(),
    description: z.string().nullable(),
    permissions: z.array(PermissionSchema),
    isSystem: z.boolean(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const CreateRoleRequestSchema = z.strictObject({
    name: z.string().trim().min(2).max(80),
    description: z.string().trim().max(500).nullable().default(null),
    permissions: z.array(PermissionSchema).min(1),
});
export const UpdateRoleRequestSchema = z.strictObject({
    name: z.string().trim().min(2).max(80).optional(),
    description: z.string().trim().max(500).nullable().optional(),
    permissions: z.array(PermissionSchema).min(1).optional(),
});
export const MembershipSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    identityId: IdSchema,
    email: z.email().nullable(),
    displayName: z.string(),
    active: z.boolean(),
    roles: z.array(RoleSchema),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const InviteMembershipRequestSchema = z.strictObject({
    email: z.email(),
    displayName: z.string().trim().min(1).max(200),
    roleIds: z.array(IdSchema).min(1),
});
export const UpdateMembershipRequestSchema = z.strictObject({
    active: z.boolean().optional(),
    roleIds: z.array(IdSchema).min(1).optional(),
});
export const MembershipListSchema = z.strictObject({
    items: z.array(MembershipSchema),
    page: PageInfoSchema,
});
export const RoleListSchema = z.strictObject({
    items: z.array(RoleSchema),
    page: PageInfoSchema,
});
